import React, { useState, useEffect } from 'react';
import { number } from 'prop-types';
import styled from 'styled-components';
import { width } from 'styled-system';
import Wrapper from '../Wrapper';

const ProgressBarWrapper = styled(Wrapper)`
  height: 6px;
  border-radius: 5px;
  background: ${({ theme }) => theme.colors.greyLighter};
  width: 100%;
`;

const Progress = styled(Wrapper)`
  height: 6px;
  background: ${({ theme }) => theme.colors.secondary};
  border-radius: 5px;
  transition: width 1s;
  ${width};
`;

const ProgressBar = ({ timeout }) => {
  const [counter, setCounter] = useState(timeout);

  useEffect(() => {
    counter > 0 && setTimeout(() => setCounter(counter - 1), 1000);
  }, [counter]);

  return (
    <ProgressBarWrapper>
      <Progress width={`${100 - (counter / timeout) * 100}%`} />
    </ProgressBarWrapper>
  );
};

ProgressBar.propTypes = {
  timeout: number,
};

export default ProgressBar;
